//Stack overflow Antwort auf "slick carousel individual slide duration" -> https://stackoverflow.com/a/72617878


$(document).ready(function(){
	
	var intervalId = 0;
	
	$slider = $('#atf-homeslider');
	
	var myslider,
			currActiveSlide,
			defaultSpeed = 7000,
			initSpeed;
	
	var firstTime = true;
 
  if($('.firstSlide').data('slideshowtime') !== 0 && $('.firstSlide').data('slideshowtime')*1000 != defaultSpeed) {
		initSpeed = $('.firstSlide').data('slideshowtime')*1000;
		firstTime = false;
	} else {
		initSpeed = defaultSpeed;
	}

  $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    currActiveSlide = slick.$slides.eq(nextSlide);
    
    if(currActiveSlide.find('.sliderContent').data('slideshowtime') != 0 && firstTime) {
    	myslider[0].slick.autoPlayClear;
    	myslider[0].slick.options.autoplaySpeed = currActiveSlide.find('.sliderContent').data('slideshowtime') * 1000;
    	myslider[0].slick.autoPlay;
    	firstTime = false;
    } else {
    	if(myslider[0].slick.options.autoplaySpeed != defaultSpeed) {
    		myslider[0].slick.autoPlayClear;
    		myslider[0].slick.options.autoplaySpeed = defaultSpeed;
    		myslider[0].slick.autoPlay;
    	}
    }
  });

	myslider = $slider.slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: initSpeed,
		centerMode: false,
		variableWidth: false,
    prevArrow: '<button type="button" class="slick-prev">prev</button>',
    nextArrow: '<button type="button" class="slick-next">next</button>'
	});	
	
	$slider.on("swipe", function(event, slick, direction) {
	  myslider.slick('slickSetOption', {
      'autoplay': false
    }, true);
	});

	$(".slick-prev, .slick-next, .slick-dots button, .slide-showvideo-button").on("click", function() {
	  myslider.slick('slickSetOption', {
      'autoplay': false
    }, true);
	});

});
